import { useEffect } from "react";
import { Link } from "react-router-dom";
import { projects } from "../data/projects";
import useReveal from "../components/useReveal";

export default function Work() {
  useReveal();

  useEffect(() => {
    document.title = "Work — Sutranode";
  }, []);

  return (
    <section className="section work-section page-with-nav-offset">
      <div className="container">
        <div className="section-heading" data-reveal>
          <div className="s-eyebrow">The Work</div>
          <h2 className="s-title">A closer look at what we've <em>built together</em> with our clients.</h2>
        </div>

        <div className="projects-grid">
          {projects.map((p, i) => (
            <ProjectCard key={p.slug} project={p} wide={i === 0} />
          ))}
        </div>

        <p className="work-note" data-reveal>
          We've been at this since 2018. These are some of the more recent threads.
        </p>
      </div>
    </section>
  );
}

function ProjectCard({ project, wide }) {
  const inner = (
    <>
      <div className="pc-banner">
        <div className="pc-banner-top">
          <div className="pc-tag-row">
            <span className="pc-tag">{project.category}</span>
            {project.tags.map((t, i) => <span key={i} className="pc-tag">{t}</span>)}
          </div>
          <div className="pc-signal" aria-hidden="true">
            <span></span><span></span><span></span>
          </div>
        </div>
        <div className="pc-meta">{project.meta}</div>
        <strong className="pc-outcome">Outcome: {project.outcome}</strong>
        <div className="pc-progress" aria-hidden="true">
          <span className="is-long"></span>
          <span className="is-mid"></span>
          <span className="is-short"></span>
        </div>
      </div>
      <div className="pc-info">
        <h3>{project.name}</h3>
        <p>{project.summary}</p>
        <div className="pc-detail-list">
          {project.details.map((d, i) => <span key={i}>{d}</span>)}
        </div>
        {project.hasCaseStudy ? (
          <span className="pc-link">Read case study →</span>
        ) : (
          <span className="pc-link-muted">Internal Tool</span>
        )}
      </div>
    </>
  );

  const className = `project-card ${wide ? "project-wide" : ""} ${!project.hasCaseStudy ? "pc-no-link" : ""}`;
  const style = { "--accent": project.accent };

  if (project.hasCaseStudy) {
    return (
      <Link to={`/work/${project.slug}`} className={className} style={style} data-reveal>
        {inner}
      </Link>
    );
  }
  return (
    <div className={className} style={style} data-reveal>
      {inner}
    </div>
  );
}
